import React from 'react';
import SiteHeader from './SiteHeader';
import Footer from '../components/sections/Footer';

/* Shared chrome for every content/marketing page: one top nav + the footer on every page,
 * so visitors can navigate anywhere and Google crawls full internal interlinking. */
const Page = ({ children }) => (
  <>
    <SiteHeader />
    {children}
    <Footer />
  </>
);

export default Page;
